export const columns = [
  { order: 1, id: 'email', labelId: 'view.users.email' },
  { order: 2, id: 'formattedRole', labelId: 'view.users.roles' },
  { order: 3, id: 'formattedRegions', labelId: 'view.users.regions' },
  { order: 4, id: 'formattedAccess', labelId: 'view.users.access' },
  { order: 5, id: 'Action', labelId: 'view.users.action', type: 'action' }
]
